import Model from "./model";
import User from "./user";
import Syllabus from "./syllabus";
import Move from "./move";

export enum StudentProgressStatus {
  NotStarted = "not started",
  InProgress = "in progress",
  Complete = "complete",
}

export default interface StudentProgress extends Model {
  user?: User;
  syllabus?: Syllabus;
  move?: Move;
  status?: StudentProgressStatus;
}
